import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import ProductShowcase from './ProductShowcase'

function Coldstore() {
  const navigate = useNavigate()

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Refrigeration for Potato Storage</Typography>
          <Typography className='page-subtitle'>
            Cold stores for fruits, vegetables and flowers.
          </Typography>
        </div>

        <div className='page-stack'>
          <ProductShowcase
            title='Potato Bulk Storage'
            subtitle='Gujarat · 1500 MT × 2'
            images={['/machines-images/Cold Stores/potato_bulk_storage.jpeg']}
            points={[
              'Refrigeration DX units — most economical',
              'Refrigeration for temperature control',
              'Humidifier for RH control',
              'Ventilation through waste-heat recovery for CO₂ control',
              'PLC automation for simultaneous control of temperature, RH and CO₂',
            ]}
            action={{ label: 'View case study', onClick: () => navigate('/product/coldstores/potato') }}
          />
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Coldstore
